<template>
  <div class="col-12 px-0">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h4><i class="fas fa-history"></i> Histórico de Status</h4>
        <div>
          <button
            class="btn active btn-outline-secondary btn-sm"
            title="Voltar"
            @click="$emit('voltar')"
          >
            <i class="mdi mdi-arrow-left"></i>Voltar
          </button>
        </div>
      </div>
    </div>
    <load v-if="loading" mode="table" />
    <div v-else class="col-md-12 mb-3">
      <table
        class="table table-bordered bg-white table-sm"
        v-for="historico in historicos"
        :key="historico.id"
      >
        <tr>
          <td class="bg-gray" colspan="2">
            O Status desta situação de
            <b>Violação de Direitos</b> foi atualizado de
            <b>{{ getStatusTitulo(historico.status_anterior) }}</b> para
            <b>{{ getStatusTitulo(historico.status_atual) }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Técnico: <b>{{ historico.user_id }}</b>
          </td>
          <td>
            Data manual da ação: <b>{{ historico.data_atualizacao }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2" v-if="historico.motivo">
            Motivo: <b>{{ historico.motivo.descricao }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <p><b>Descrição do Motivo</b></p>
            {{ historico.observacoes }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id", "familia", "status"],
  data() {
    return {
      loading: true,
      historicos: {},
    };
  },
  mounted() {
    this.getHistorico();
  },
  methods: {
    getStatusTitulo(id) {
      if (this.status.length != undefined) {
        const result = this.status.filter((item) => item.id == id);
        return result[0] ? result[0].descricao : "";
      }
    },

    getHistorico() {
      this.loading = true;
      axios
        .get("api/dashboard/violacaodedireitos/historico/status/" + this.id)
        .then((response) => {
          this.historicos = response.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(() => {
          swal.fire({
            title: "Ops!",
            html:
              "Histórico de Status não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
  },
};
</script>
